import {
	MESApiService,
	ShiftData,
	getMomentTz,
	spParameter,
} from "@dexteel/mesf-core";
import { isDate } from "lodash-es";
const moment = getMomentTz();

export interface Props {
	Start?: Date;
	End?: Date;
	SearchTerm?: string;
}
export const getShiftsWithSearch = async ({
	Start,
	End,
	SearchTerm,
}: Props) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({
		name: "Start",
		value: isDate(Start) ? Start.toISOString() : null,
	});
	parameters.push({
		name: "End",
		value: isDate(End) ? End.toISOString() : null,
	});

	parameters.push({
		name: "SearchTerm",
		value: SearchTerm || null,
	});

	const resp = await apiService.callV2(
		"[SWV].[GetShiftsWithSearch]",
		parameters,
	);

	if (resp.ok) {
		resp.data = resp.data.tables[0].rows.map((row: ShiftData) => {
			return {
				...row,
				Start: moment.utc(row.Start).toDate(),
				End: moment.utc(row.End).toDate(),
			};
		});
	}

	return resp;
};
